import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./dash0.ts";
import "./index.css";
import "@xyflow/react/dist/style.css";
import "./installLocalMonaco";
import App from "./App.tsx";
import { setupApiInterceptor } from "./lib/api-interceptor.ts";
import { Sentry } from "./sentry.ts";
import "./posthog.ts";
import { ErrorPage } from "./components/ErrorPage.tsx";

import { initGoogleTagManager } from "./lib/googleTagManager";
import { registerServiceWorker } from "./lib/registerServiceWorker";

initGoogleTagManager();
registerServiceWorker();

// Setup the API interceptor to handle 401 responses
setupApiInterceptor();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
